import React, { useState } from "react";
import { FilterByVersion } from "./FilterByVersion";
import { FilterBarClient } from "./FilterBarClient";
import { VisibleActiveSoft } from "./VisibleActiveSoft";
import stateFilter from "../../state/state.filter";
import ApiData from "../../api/ApiData";
import { observer } from "mobx-react-lite";
import Media from "../../api/Media";

export const BarClient = observer(
  ({
    versionFilterOn,
    setVersionFilterOn,
    setIdSearch,
    v4Layout,
    showNoProductionFilter = true,
  }) => {
    const [versionUiResetKey, setVersionUiResetKey] = useState(0);
    const setActiveClient = async () => {
      stateFilter.setParameter(
        "filter_active_client",
        !stateFilter.filter_active_client,
      );
      stateFilter.setLocalStorage(
        "filter_active_client",
        stateFilter.filter_active_client,
      );
    };

    const onClickServer = () => {
      stateFilter.setParameter(
        "filter_active_server",
        !stateFilter.filter_active_server,
      );
      stateFilter.setLocalStorage(
        "filter_active_server",
        stateFilter.filter_active_server,
      );
    };

    if (ApiData.company.clients_soft !== null) {
      if (v4Layout) {
        return (
          <>
            <div className="filter-group">
              <VisibleActiveSoft
                v4Layout
                onClickActive={setActiveClient}
                onClickServer={onClickServer}
              />
            </div>
            <div className="filter-group filter-group-actions">
              <FilterByVersion
                v4Layout
                versionFilterOn={versionFilterOn}
                setVersionFilterOn={setVersionFilterOn}
                versionUiResetKey={versionUiResetKey}
              />
              <FilterBarClient
                v4Layout
                setIdSearch={setIdSearch}
                setVersionFilterOn={setVersionFilterOn}
                onResetVersionUi={() =>
                  setVersionUiResetKey((key) => key + 1)
                }
                showNoProductionFilter={showNoProductionFilter}
              />
            </div>
          </>
        );
      }

      return (
        <div className="bar_filter_client_company">
          <VisibleActiveSoft
            onClickActive={setActiveClient}
            onClickServer={onClickServer}
          />
          {!Media.mobile ? (
            <FilterByVersion
              versionFilterOn={versionFilterOn}
              setVersionFilterOn={setVersionFilterOn}
            />
          ) : (
            null
          )}
          {!Media.mobile ? (
            <FilterBarClient
              setIdSearch={setIdSearch}
              setVersionFilterOn={setVersionFilterOn}
            />
          ) : (
            null
          )}
        </div>
      );
    }
  },
);
